import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetPortfolioUserDetailsAction = function () {

}


GetPortfolioUserDetailsAction.prototype = {

	getPortfolioUserDetails: function (userId,portfolioId) {

		restClient.getPortfolioUserDetails(userId,portfolioId, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.GET_PORTFOLIO_USER_DETAILS,
						data: error
					});
				}
			} else {
				//response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_PORTFOLIO_USER_DETAILS,
					data: response
				});
			}
		})
	}
}

export default new GetPortfolioUserDetailsAction();